/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Media from 'react-media';
import mbpUtil from '@api-util/mbp';
import {
    string, object, bool, func, array,
} from 'prop-types';
// import Grid from '@material-ui/core/Grid';
import { Tab, Tabs } from '@material-ui/core';
import { connect, useDispatch, useSelector } from 'react-redux';
import { compose } from 'recompose';
import ReactHtmlParser from 'react-html-parser';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { getBreadcrumbArray } from '../common/commonProductPageHelper';
import { getBaseCode } from '../../../../../helpers/tracking/product/dataLayerProductHelpers';
import { addToCartDataType } from '../common/types';

import ProductImageUI from '../ProductImageUI';
import ProductTitle from '../ProductTitle/ProductTitle';
import ProductReview from '../ProductReview';
import GraphqlProductSkus from '../GraphqlPDPSkus/GraphqlProductSkus';
import GraphqlAddonContainer from '../GraphqlAddon/GraphqlAddonContainer';
import GCIPersonalization from '../CGC/GCIPersonalization';
import SnipeBanner from '../ExpressShip/SnipeBanner';
import GraphqlAgeVerification from '../CommonProductAgeZipVerify/CommonProductAgeZipVerify';
import PersonalizeYourGift from '../PersonalizeYourGift/PersonalizeYourGift';
import ProductQuantity from '../ProductQuantity';
import GraphqlPDPPromoContainer from '../GraphqlPDPPromotionBlock/GraphqlPDPPromoContainer';
import SubscriptionProductBannerUI from '../SubscriptionProductBannerUI';
import PmallSummary from '../../../../../helpers/components/PmallPersonalization/PmallSummary';
import PmallPersonalization from '../../../../../helpers/components/PmallPersonalization/PmallPersonalization';
import NBCUMovieBanner from '../NBCUMovie/NBCUMovieBanner';
import PDPAddToCart from '../PDPAddToCart/PDPAddToCart';
import GoDeluxe from '../GraphqlPDPSkus/GoDeluxe';
import PDPDeliveryPopupContainer from '../GraphqlPDPDeliveryPopup/PDPDeliveryPopupContainer';
import OneClickPaymentBuilder from '../OneClickPayments/OneClickPaymentBuilder';
import SmartGift from '../SmartGift/SmartGift';
import PDPVariantController from './PDPVariantController';
import PassportBannerUI from '../../../../../pages/Checkout/containers/CheckoutFloral/Partials/Passport/PassportBannerUI/PassportBannerUI';
import ProductDetails from '../ProductDetails/ProductDetails';
import QuestionsAndAnswersAI from '../QuestionsAndAnswers/QuestionsAndAnswersAI';
import { getActiveABTest, getActiveABTests } from '../../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import SubstitutionMessage from '../SubstitutionMessage/SubstitutionMessage';
import MarketingSpotsPDP from '../MarketingSpotsPDP/MarketingSpotsPDPContainer';
import Track from './Track';
import GraphqlProductListAdCategoryContainer from '../GraphqlProductListAddCategroy/GraphqlProductListAdCategoryContainer';
import MarketingSpotsNupPDP from '../MarketingSpotsNupPDP';
import PLAProductTitle from '../ProductTitle/PLAProductTitle';
import { getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';
import PLAMobileProductTitle from '../ProductTitle/PLAMobileProductTitle';
import PassportBundleBanner from '../../../../ContentTypeComponents/PassportBanner/PassportBundleBanner';
import PassportBannerContainer from './PassportBannerContainer';
import { getPassportBundleData } from '../../../../../../state/ducks/Common/Common-Selectors';
import useIsPlaPage from '../../../../../helpers/hooks/useIsPlaPage';
import RecommendationsBuilder from './RecommendationsBuilder';
import { setSelectedInlineAddons } from '../../../../../../state/ducks/App/App-Actions';
import YotpoReviewsLegalCopy from '../YotpoReviewsLegalCopy';
import replaceSpecialChar from '../../../../../helpers/replaceSpecialChar';
import PromoMessageUI from '../PromoMessageUI';
import PLAProductIcon from '../PLAProductIcon/PLAPDPIconQuery';
import PLACollectionRecsABWrapper from '../PLAProductIcon/PLACollectionRecsABWrapper';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import PDPLargePromoContainer from './PDPLargePromoContainer';
import PLAPDPGiftFinderQuery from '../PLAGiftFinder/PLAPDPGiftFinderQuery';
import useIsDisplayChannel from '../../../../../helpers/hooks/useIsDisplayChannel';
import useClickStreamCustomEventsTracking from '../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { getCurrentPageType } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';
import PassportEligibleImage from '../GraphqlPDPSkus/PassportEligibleImage';
import isProductListingAd from '../../../../../helpers/isProductListingAd';
import PDPSkeleton from '../../../GraphqlSkeletonComponents/PDPSkeleton';
import MobilePDPSkeleton from '../../../GraphqlSkeletonComponents/MobileSkeleton/MobilePDPSkeleton';
import PLASkeleton from '../../../GraphqlSkeletonComponents/PLASkeleton';
import YotpoClickEvent from './YotpoClickEvent';
import PLARecsABWrapper from '../PLARecommendations/PLARecsABWrapper';
import LoadCardIslePDP from '../../../../vendors/CardIsle/LoadCardIslePDP';
import GraphqlProductImageUI from '../ProductImageUI/v1/GraphqlProductImageUI';
import ProductTitleTop from '../GraphqlPDPSkus/ProductTitleTop';
import useStickyAtcExperiment from '../common/useStickyAtcExperiment';
import useExperience from '../../../../../helpers/Personalization/useExperience';
import isPassportEnrollmentActive from '../../../../../helpers/passportEnrollmentVisibility';

const useStyles = makeStyles((theme) => ({
    breadCrumbBody: {
        margin: '20px auto',
        maxWidth: 1380,
        [theme.breakpoints.down('md')]: {
            padding: '0 10px 0',
        },
        // Desktop & Tablet
        '&--desktop': {
            [theme.breakpoints.up('sm')]: {
                display: 'flex',
            },
        },
        // Mobile
        '&--mobile': {
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                justifyContent: 'center',
            },
        },
        // Mobile
        '&--mobile-pdp-redesign': {
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                padding: '0px 16px',
                margin: '14px auto 14px auto',
                '& ol': {
                    flexWrap: 'nowrap',
                    overflow: 'auto',
                },
                '& li': {
                    color: '#2f2f2f',
                },
                '& li a': {
                    color: '#2f2f2f',
                },
            },
        },
        '&--mobile.club-mobile-pdp': {
            [theme.breakpoints.down('sm')]: {
                display: 'block',
                textAlign: 'left',
                padding: '0 10px 0',
                '& li': {
                    display: 'inline-block',
                },
                '& ol': {
                    textAlign: 'left',
                },
            },
        },
    },
    showBreadCrumbBody: {
        display: 'block',
        padding: '0 12px',
        marginTop: '5px',
        marginBottom: '0',
    },
    contentTop: {
        // Desktop
        margin: '0px auto',
        maxWidth: '1380px',
        color: theme.palette.black,
        // Tablet
        [theme.breakpoints.down('md')]: {
            margin: '20px 20px 30px',
        },
        // Mobile
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 10px 0',
        },
    },
    contentLeft: {
        width: '100%',
        // Tablet
        [theme.breakpoints.down('md')]: {
            flex: '1 1 auto',
            display: 'flex',
            maxWidth: '40%',
            marginRight: '20px',
            flexDirection: 'column',
        },
        // Mobile
        [theme.breakpoints.down(600)]: {
            maxWidth: '100%',
        },
        marginRight: '24px',
        maxWidth: '665px',
    },
    contentRight: {
        width: '100%',
        maxWidth: '980px',
        // Tablet
        [theme.breakpoints.down('md')]: {
            width: 'calc(60% - 20px)',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '100%',
        },
    },
    contentBottom: {
        width: '100%',
        margin: '40px auto 60px auto',
        maxWidth: '1380px',
        // Tablet
        [theme.breakpoints.down('md')]: {
            padding: '0 20px 0',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 15px 0',
            padding: '0',
        },
    },
    prReviewDisplay: {
        '& .p-w-r .pr-review-snapshot .pr-review-snapshot-simple .pr-review-snapshot-snippets-headline': {
            marginRight: '10px',
        },
        '& .pr-snippet': {
            display: 'flex',
            minWidth: 'fit-content',
        },
        '& .p-w-r .modal__body .pr-read-review-flagging-in .pr-rd-helpful-action-btn-group': {
            display: 'flex',
        },
        '& .pr-rd-helpful-action-group': {
            display: 'flex',
        },
        [theme?.breakpoints?.down('980')]: {
            '& .p-w-r .pr-review-snapshot .pr-snippet .pr-snippet-stars-png .pr-star-v4': {
                height: '15px',
                width: '15px',
            },
            '& .p-w-r .pr-review-snapshot.pr-snapshot-mobile .pr-review-snapshot-simple .pr-snippet-rating-decimal': {
                display: 'none',
            },
            '& .pr-review-snapshot-snippets': {
                justifyContent: 'left',
            },
            '& .p-w-r .pr-review-display .pr-rd-helpful-action .pr-rd-helpful-text': {
                display: 'block',
            },
            '& .pr-rd-flag-review-container': {
                display: 'block',
            },
        },
        [theme?.breakpoints?.down('sm')]: {
            '& .pr-snippet': {
                flexDirection: 'column',
                marginTop: '-20px',
            },
        },
        [theme?.breakpoints?.down('xs')]: {
            '& .p-w-r .pr-review-display .pr-rd-helpful-action .pr-rd-helpful-text': {
                display: 'none',
            },
            '& .pr-rd-flag-review-container': {
                display: 'none',
            },
            '& .pr-snippet': {
                flexDirection: 'column',
            },
        },
    },
    foodRoot: {
        width: '98%',
        margin: 'auto',
        '& .yotpo-main-widget .yotpo-no-reviews .yotpo-regular-box': {
            height: 'auto',
            padding: 5,
        },
    },
    flowerRoot: {
        width: '100%',
        margin: 'auto',
        overflow: 'hidden',
    },
    hidePRStarDistribution: {
        '& .p-w-r .pr-review-snapshot.pr-review-enhanced .pr-review-snapshot-block-container .pr-review-snapshot-block:last-child': {
            display: 'none',
        },
    },
    // plaContentTop: {
    //     // Desktop
    //     margin: '0px auto',
    //     maxWidth: '1380px',
    //     color: theme.palette.black,
    //     // Tablet
    //     [theme.breakpoints.down('md')]: {
    //         flexDirection: 'column',
    //     },
    //     // Mobile
    //     [theme.breakpoints.up('sm')]: {
    //         display: 'flex',
    //     },
    //     [theme.breakpoints.down('sm')]: {
    //         margin: '0 5px 10px 5px',
    //         '& $ratingStars': {
    //             display: 'flex',
    //         },
    //     },
    // },
    // plaView: {
    //     // Desktop
    //     margin: '0px auto',
    //     marginRight: '20px',
    //     maxWidth: '1380px',
    //     color: theme.palette.black,
    //     // Tablet
    //     [theme.breakpoints.down('md')]: {
    //         // margin: '20px 20px 30px',
    //         margin: '-50px auto 0 auto',
    //         '& $productRatingContainer': {
    //             marginBottom: '20px',
    //         },
    //     },
    //     // Mobile
    //     [theme.breakpoints.up('sm')]: {
    //         display: 'flex',
    //         marginTop: 'unset',
    //     },
    //     [theme.breakpoints.down('sm')]: {
    //         margin: '0 0 10px 0',
    //     },
    // },
    productName: {
        width: '100%',
        marginTop: 0,
        fontSize: '24px',
        [theme.breakpoints.down('md')]: {
            marginBottom: '10px',
        },
        // Mobile
        [theme.breakpoints.down(600)]: {
            display: 'none',
        },
    },
    recommendations: {
        '& + [class*="GraphqlProductDetailsUI-pdpShortStyle"]': {
            marginTop: '28px',
        },
        '& > div:not(:first-of-type) > div': {
            paddingTop: '0',
        },
        '& > div:not(:last-of-type) > div': {
            paddingBottom: '0',
        },
        '& .pdp-recs>div:not(:last-of-type)': {
            paddingBottom: 0,
        },
        '& .pdp-recs>div:not(:first-of-type)': {
            paddingTop: 0,
        },
    },
    yotpoRatings: {
        '& .yotpo-main-widget .bottom-line-items': {
            display: 'none',
        },
        '& .yotpo-main-widget .yotpo-bottomline-box-1': {
            display: 'none',
        },
        '& .yotpo-main-widget .yotpo-bottomline-box-2': {
            display: 'none',
        },
        '& .yotpo-main-widget .reviews-amount': {
            visibility: 'hidden',
            position: 'relative',
            '&:after': {
                visibility: 'visible',
                position: 'absolute',
                content: '"Selected Customer Reviews"',
                top: 0,
                left: 0,
                width: '400px',
            },
        },
        '& .yotpo-main-widget .yotpo-nav ul li:first-child': {
            minWidth: '210px',
            visibility: 'hidden',
            position: 'relative',
            '&:after': {
                visibility: 'visible',
                position: 'absolute',
                content: '"Selected Customer Reviews"',
                top: 0,
                left: 0,
                width: '400px',
            },
        },
        '& .filters-dropdown .yotpo-dropdown-button .selected': {
            width: '90%',
        },

    },
    heading: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            height: '100%',
        },
    },
    ooakSliderContainer: {
        width: '100%',
        margin: '0 auto',
        textAlign: 'center',
    },
    ooakSliderHeader: {
        fontFamily: 'ivypresto-text,PlayfairDisplayBold, serif',
        fontSize: '2em',
        [theme.breakpoints.down('md')]: {
            fontSize: '1.5em',
        },
    },
    headerImageContainer: {
        display: 'flex',
    },
    headerImage: {
        width: '100%',
    },
    plaBreadCrumb: {
        margin: '22px auto',
        padding: '0px',
        [theme.breakpoints.down('1025')]: {
            margin: '10px 0px 14px 0px',
        },
        [theme.breakpoints.down('600')]: {
            display: 'none',
        },
    },
    foodWrapper: {
        [theme.breakpoints.down('600')]: {
            width: '100%',
        },
    },
    flowerWrapper: {
        [theme.breakpoints.up('600')]: {
            overflow: 'unset !important',
        },
    },
    prQuestionDisplay: {
        '& .p-w-r .pr-waqwaa': {
            maxWidth: '100%',
        },
        '& .p-w-r .pr-qa-display .pr-btn-ask-question .pr-cross-icon': {
            display: 'none',
        },
    },
}));

const StandardProductsPage = ({
    addToCartData,
    baseProduct,
    brand,
    content,
    deliveryData,
    deliveryIndicator,
    deliverySLA,
    deviceType,
    disableAddToCart,
    featureFlags,
    getUpdatedPersonalizedProdData,
    handleMiniCartModalClick,
    handleMobileAgeVerification,
    handlePersonalizeInputChange,
    handleSkuChange,
    hasAddons,
    hasWine,
    hide18FCheckbox,
    isAddToCartEnabled,
    isPassportBundleItem,
    isPassportBundleProduct,
    isPlaEnabled,
    isStandAloneMovieSku,
    location,
    mobileAgeVerificationOpen,
    passportData,
    passportMemberImg,
    personalization,
    personalizedData,
    presentation_family,
    product,
    productBaseContent,
    productDisplay,
    productUrl,
    quantity,
    selectedSku,
    setProductQuantity,
    skuConfig,
    smartGiftAddressSection,
    smartGiftLetThemKnowSection,
    sortedData,
    subscription,
    subscriptionDetails,
    triggerSubscriptionCheck,
    updateWineStatus,
    urlParams,
    validVaseConfiguratorSku,
    setVaseConfiguratorSku,
    trackEvent,
    yotpoCustomerReviewsGallery,
    activeABTests,
    passportBundleDetails,
    handleSkuClick,
    isPassportAfterCta,
}) => {
    // when we refresh the page then clear the redux state for inline addons
    const dispatch = useDispatch();
    const isPlaPage = useIsPlaPage();
    const isDisplayChannel = useIsDisplayChannel();
    const { clickableDivRef } = YotpoClickEvent(dispatch);
    const ssrDeviceType = useSelector(getSSRDeviceType);
    const pageType = useSelector(getCurrentPageType);
    const isPlaDisable = !isPlaPage && !isDisplayChannel && !isProductListingAd(location.search);

    const isStickyAtcExperimentEnabled = !!featureFlags['is-sticky-atc-enabled'] && ssrDeviceType === 'mobile';
    const { stickyAtcEnabled, stickyAtcRequiresSavedZip, experimentTracking: stickyAtcExperimentTracking } = useStickyAtcExperiment({
        isEnabled: isStickyAtcExperimentEnabled,
        shouldTrackImpression: true,
    });
    const isPlaRedesignEnabled = featureFlags['force-pla-pdp-redesign-enabled'] && (isPlaPage || isDisplayChannel || isProductListingAd(location?.search));
    const isForcePdpRedesignEnabled = featureFlags['is-force-pdp-redesign-enabled'];
    const isForcePdpAddToCartRedesignEnabled = featureFlags['is-force-pdp-redesign-atc-color-enabled'];
    const isPdpRedesignEnabled = isPlaRedesignEnabled ? true : isForcePdpRedesignEnabled && isPlaDisable;

    const showProductTitleTop = featureFlags['is-force-pdp-product-title-top-enabled'] && ssrDeviceType === 'mobile';
    const isPdpRedesignShortEnabled = featureFlags['is-force-pdp-short-length-redesign-enabled'];
    const isPdpRedesignSkuEnabled = featureFlags['is-force-pdp-sku-selector-redesign-enabled'];
    // PowerReviews A/B Test to hide or show Image Carousel
    const isPowerReviewsImageCarousel = featureFlags['is-power-reviews-image-carousel-enabled'];

    // hide pdp delivery Button
    const { loading: pdpDeliveryLoading, variables: pdpDeliveryVariable, data: pdpDeliveryData } = useExperience({
        queryName: 'pdpDeliveryType',
        interactionName: `${brand.domain}-hide-delivery-type-FPT-GPT`,
        type: 'product',
    });
    const deliveryTypeGroup = pdpDeliveryData?.experience?.experiment;
    const hideDeliveryType = deliveryTypeGroup?.value;
    const deliveryTypeTracking = pdpDeliveryData?.experience?.experimentTracking;

    useClickStreamCustomEventsTracking({
        deliveryTypeTracking,
        isFireImpression: true,
        page: { type: pageType },
    });
    useClickStreamCustomEventsTracking({
        experimentTracking: stickyAtcExperimentTracking,
        isFireImpression: isStickyAtcExperimentEnabled,
        page: { type: pageType },
    });
    useEffect(() => {
        if (typeof deliveryTypeGroup !== 'undefined' && !window.wuHideDeliveryTypeFired && deliveryTypeGroup) {
            const eventParam = {
                eventCategory: 'Experiment',
                eventAction: 'Hide Delivery Type',
                eventLabel: hideDeliveryType ? 'Variant' : 'Control',
                feature_detail: hideDeliveryType ? 'Variant' : 'Control',
                feature_element: 'Hide Delivery Type',
                feature_category: 'Experiment',
            };
            dispatch(trackEvent(eventParam));
            window.wuHideDeliveryTypeFired = true;
        }
        return () => {
            window.wuHideDeliveryTypeFired = false;
        };
    }, [deliveryTypeGroup]);

    useEffect(() => {
        if (!isPowerReviewsImageCarousel) {
            const intervalId = setInterval(() => {
                const powerReviewsImageDisplay = document.querySelector('[data-testid="review-image-display"]');
                if (powerReviewsImageDisplay) {
                    powerReviewsImageDisplay.style.display = 'none';
                    clearInterval(intervalId);
                }
            }, 1000);
        }
    }, []);

    const classes = useStyles();
    const floralPLARedesign = useSelector(getActiveABTest('is_floral_pla_redesign'));

    // data rinse
    let productName = ReactHtmlParser(replaceSpecialChar(product.name));
    if (isPassportBundleProduct?.enable) {
        const bundleText = passportData?.passport_bundle?.pdpage_passport_bundle_title || ' & Passport Bundle';
        productName = `${productName} ${bundleText}`;
    }
    const isMovieProduct = productName?.[0]?.toLowerCase();
    const isPDPDeliveryPopupShow = product?.categories?.includes('digital_products') || isMovieProduct?.includes('digital movie gift');
    const { isPassportEligible = false } = product;
    const isMobile = ssrDeviceType === 'mobile';
    const productDeliveryType = product && product.availability && product.availability.productDeliveryType ? product.availability.productDeliveryType : '';
    const productImage = `${product.image?.path + product.image?.name}x.jpg`;
    const yotpoSliderProduct = (location?.pathname === '/red-roses-24-stem-91790' || location?.pathname === '/red-roses-91790') && featureFlags['is-yotpo-gallery-enabled'];
    const showOoakYotpoSlider = activeABTests?.ooakYotpoGallery === 'VARIANT';
    const { gallery_id = '', heading = '', sub_heading = '' } = yotpoCustomerReviewsGallery;
    const headerBanner = productBaseContent?.entries[0]?.pdp_header_banner || {};
    const isPDPVariationDesign = featureFlags['is-pdp-new-layout-enabled'] && brand.code === 'FL';

    let hideProductRecomendation = false;
    if (isPlaPage && floralPLARedesign === 'VARIANT' && ssrDeviceType !== 'mobile') {
        hideProductRecomendation = true;
    } else if (isPlaPage && ssrDeviceType === 'mobile') {
        hideProductRecomendation = true;
    }
    const yotpoConfig = {
        name: product.name,
        partNumber: getBaseCode(product.partNumber),
        // eslint-disable-next-line react/destructuring-assignment
        price: selectedSku,
    };

    // Lots of legacy code around the passport eligiblity and AB tests, needs cleanup
    const isPassportEligiblePdpHidden = featureFlags['is-passport-eligible-pdp-hidden'];
    const enrollmentPage = isPlaEnabled ? 'pla' : 'product';
    const hasEnrollmentConfig = Object.prototype.hasOwnProperty.call(featureFlags, 'is-celebrations-passport-enrollment-active-ft');

    /**
     * @description - Passport elagibiility banner
     * - Display banner if product is eligable and flag is enabled
     * - isPassportEligiblePdpHidden is highest in priority
     * @return {bool}
     */
    const isPassportBannerEnabled = () => {
        if (hasEnrollmentConfig && !isPassportEnrollmentActive(featureFlags, enrollmentPage)) return false;
        if (isPassportEligiblePdpHidden) return false;
        // flag from contentStack to show/hide passport banner on PDP Page
        const disablePassportEnrollment = passportData?.passport_up_sell_conditional_logic_at_entrance?.disable_passport_enrolment;
        if (disablePassportEnrollment) return false;
        // flag from contentStack for utm_param
        if (location?.search) {
            const url = location.search.match('(utm_param)=([^&]+)');
            if (url && url.length > 2 && url[1] === 'utm_param') {
                if (passportData?.passport_up_sell_conditional_logic_at_entrance) {
                    const { utm_param, enable } = passportData.passport_up_sell_conditional_logic_at_entrance;
                    if (enable) {
                        if (url[2] === utm_param) return false;
                    }
                }
            }
        }
        if (isPassportEligible && featureFlags['is-prime-free-ship-icon-enabled']) return true;
        return false;
    };
    const shouldShowPassportEligiblePdpTag = isPassportBannerEnabled();

    /**
     * @description Smartgift feature visability
     * - Display smartgift if flag is enabled
     * @return {bool} bool
     */
    const isSmartGiftEnabled = () => {
        let isProductHasSmartGiftEnabled = true; // for flowers brand handle by LD.
        if (presentation_family === 'food') {
            isProductHasSmartGiftEnabled = product?.isSmartgiftEnabled; // food brands will use product based smart gift
        }
        if (featureFlags['is-smart-gift-enabled'] && isProductHasSmartGiftEnabled) return true;
        return false;
    };

    const productNotAvailable = content?.entries?.[0]?.product_not_available || {};

    const [pmallModalOpen, setPmallModalOpen] = useState(false);
    const [movieSelected, selectMovieSku] = useState({});

    // Product reviews
    const isPdpReviewsEnabled = featureFlags['is-pdp-reviews-enabled'];
    const isPowerReviewEnabled = featureFlags['is-power-review-enabled'];
    const isForcePowerReviewsDisplayAndSnippet = featureFlags['force-powerreviews-display-and-snippet'];
    const [wineModalOpen, setWineModalOpen] = useState(mobileAgeVerificationOpen);
    const questionAndAnswersAIEnabled = featureFlags['ai-questions-and-answers-pdp'];
    const handleClose = () => {
        setWineModalOpen(false);
    };
    const isVariantPdpPowerReviewsDisplayAndSnippet = isForcePowerReviewsDisplayAndSnippet && isPdpReviewsEnabled && isPowerReviewEnabled;
    // Hide either aggregated star rating or star distribution
    const isShowProductReviewsStarDistribution = featureFlags['is-show-product-reviews-star-distribution'];
    const isDeliveryPopUpEnabled = useSelector(getFeatureFlag('is-design-and-delivery-popup-enabled'));
    const isDeliveryEnabled = isDeliveryPopUpEnabled && brand?.id === '1001' && (product?.brandId === '1010' || product?.brandId === '1026' || product?.brandId === '1027');
    const ffCurrentBrandPmallAtcOnSave = useSelector(getFeatureFlag('is-pmall-product-save-atc-enabled'));
    const cardIsleFlag = featureFlags['card-isle-product-type-control'];
    const cardIsleEnabled = !!cardIsleFlag?.[productDeliveryType?.toLowerCase()];
    const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
    const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';
    const isPmallPersonalizationTypeAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'personalization_type_enabled');
    const pmallPersonalizationType = !!isPmallPersonalizationTypeAttr?.values?.[0]?.value;
    const isPmallCardIsleFlow = ffCurrentBrandPmallAtcOnSave
        && featureFlags['is-pmall-enabled']
        && (product?.brandId === '1030' || product?.brandId === '1033' || isPmallPersonalizationEnabled || pmallPersonalizationType)
        && selectedSku?.personalization?.personalizationAllowed;
    // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page
    const components = {
        ProductImageUI: (pdpVariantName) => (
            <ProductImageUI
                pdpVariantName={pdpVariantName}
                brand={brand}
                content={content}
                data={product}
                location={location}
                presentation_family={presentation_family}
                product={product} // TODO: this is passed twice? see data prop
                productBaseContent={productBaseContent}
                productName={productName}
                productNameDisplay={productDisplay}
                selectedSku={selectedSku}
                smartGiftLetThemKnowSection={smartGiftLetThemKnowSection}
                isSmartGiftEnabled={isSmartGiftEnabled()}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                showProductTitleTop={showProductTitleTop}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
            />
        ),

        SmartGift: (pdpVariantName) => (
            <SmartGift
                pdpVariantName={pdpVariantName}
                product={product}
                selectedSku={selectedSku}
                image={productImage}
                smartGiftAddressSection={smartGiftAddressSection}
                smartGiftLetThemKnowSection={smartGiftLetThemKnowSection}
                isPlaEnabled={isPlaEnabled}
            />
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        ProductTitle: (pdpVariantName) => (
            <ProductTitle
                pdpVariantName={pdpVariantName}
                brand={brand}
                presentationFamily={presentation_family}
                isPlaEnabled={isPlaEnabled}
                productName={productName}
                isPassportBannerEnabled={shouldShowPassportEligiblePdpTag}
                skuEnabledOnMobile={skuConfig?.show_sku_on_mobile}
                partNumber={product.partNumber}
                selectedSku={selectedSku}
                productBrandId={product?.brandId}
                skuCount={product?.productSkus?.length || 0}
                featureFlags={featureFlags}
                product={product}
                productUrl={productUrl}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                showProductTitleTop={showProductTitleTop}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
                isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                showShopName={product?.showShopName}
            />
        ),

        PLAProductTitle: (pdpVariantName) => (
            <PLAProductTitle
                pdpVariantName={pdpVariantName}
                brand={brand}
                presentationFamily={presentation_family}
                isPlaEnabled={isPlaEnabled}
                productName={productName}
                isPassportBannerEnabled={shouldShowPassportEligiblePdpTag}
                skuEnabledOnMobile={skuConfig?.show_sku_on_mobile}
                partNumber={product.partNumber}
            />
        ),

        PLAProductIcon: (isDesktop = false) => (
            <PLACollectionRecsABWrapper
                plaRedesignDesktop={isDesktop}
                brand={brand}
                partNumber={product.partNumber}
                productName={productName}
                skuData={sortedData}
            />
        ),

        PLAMobileProductTitle: (pdpVariantName) => (
            <PLAMobileProductTitle
                pdpVariantName={pdpVariantName}
                brand={brand}
                presentationFamily={presentation_family}
                isPlaEnabled={isPlaEnabled}
                productName={productName}
                isPassportBannerEnabled={shouldShowPassportEligiblePdpTag}
                skuEnabledOnMobile={skuConfig?.show_sku_on_mobile}
                partNumber={product.partNumber}
                showShopName={product?.showShopName}
                selectedSku={selectedSku}
                productBrandId={product?.brandId}
            />
        ),

        ProductReview: (pdpVariantName) => (
            <ProductReview
                pdpVariantName={pdpVariantName}
                product={product}
                selectedSku={selectedSku}
                productUrl={productUrl} // comes off content from 2 levels up
                skuEnabledOnMobile={skuConfig?.show_sku_on_mobile}
                isStandardPdp
                isVariantPdpPowerReviewsDisplayAndSnippet={isVariantPdpPowerReviewsDisplayAndSnippet}
            />
        ),

        GraphqlProductSkus: (pdpVariantName, hideUpsells = false, hidePrice = false) => (
            <GraphqlProductSkus
                pdpVariantName={pdpVariantName}
                baseProductSku={baseProduct}
                brand={brand}
                skuConfig={skuConfig}
                handleMiniCartModalClick={handleMiniCartModalClick}
                handleSkuChange={handleSkuChange}
                isPassportBundleProduct={isPassportBundleProduct || {}}
                location={location}
                presentation_family={presentation_family}
                product={product}
                productUrl={productUrl}
                movieSelected={movieSelected?.skuSelected ? movieSelected : null}
                hasWine={hasWine}
                isStandAloneMovieSku={isStandAloneMovieSku}
                selectedSku={selectedSku}
                skuData={sortedData}
                setVaseConfiguratorSku={setVaseConfiguratorSku}
                floralPLARedesign={floralPLARedesign}
                isPassportBannerEnabled={shouldShowPassportEligiblePdpTag}
                PLARedesignMobileOnly={false}
                handleSkuClick={handleSkuClick}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
                hideUpsells={hideUpsells}
                hidePrice={hidePrice}
            />
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        GraphqlAddonContainer: (pdpVariantName) => (
            <GraphqlAddonContainer
                pdpVariantName={pdpVariantName}
                product={product}
                skuData={sortedData}
                brand={{ domain: product.brand || brand.domain }}
                handleMiniCartModalClick={handleMiniCartModalClick}
                brandId={brand?.id}
                partNumber={product?.partNumber}
                categoryId={location.state?.categoryId || ''}
                subscription={subscription}
                subscriptionDetails={subscriptionDetails}
                presentation_family={presentation_family}
                disableAddToCart={disableAddToCart}
                isAddToCartEnabled={isAddToCartEnabled}
                categoryPath={location.state?.categoryPath || ''}
                categoryName={location.state?.categoryName || ''}
                selectedSku={selectedSku}
                productSkus={product?.productSkus}
                updateWineStatus={updateWineStatus}
                deliveryData={deliveryData}
                mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                handleMobileAgeVerification={handleMobileAgeVerification}
                addToCartData={addToCartData}
                addonGroups={product?.addonGroups}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                content={content}
            />
        ),

        GCIPersonalization: (pdpVariantName) => (
            <GCIPersonalization
                pdpVariantName={pdpVariantName}
                selectedSku={selectedSku}
                getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        ),

        SnipeBanner: (pdpVariantName) => (
            <SnipeBanner
                pdpVariantName={pdpVariantName}
                snipeName={product?.image?.snipe}
            />
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        GraphqlAgeVerification: (pdpVariantName) => (
            <GraphqlAgeVerification
                pdpVariantName={pdpVariantName}
                updateWineStatus={updateWineStatus}
                selectedSku={selectedSku}
                deliveryData={deliveryData}
                productSkus={product?.productSkus}
                mobileAgeVerificationOpen={wineModalOpen}
                handleMobileAgeVerification={handleMobileAgeVerification}
                addToCartData={addToCartData}
                featureFlags={featureFlags}
                quantity={quantity}
                setOpen={handleClose}
            />
        ),

        PersonalizeYourGift: (pdpVariantName) => (
            <PersonalizeYourGift
                pdpVariantName={pdpVariantName}
                selectedSku={selectedSku}
                product={product}
                personalization={personalization}
                handlePersonalizeInputChange={handlePersonalizeInputChange}
                getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
            />
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        ProductQuantity: (pdpVariantName) => (
            <ProductQuantity
                pdpVariantName={pdpVariantName}
                product={product}
                quantity={quantity}
                setProductQuantity={setProductQuantity}
            />
        ),

        GraphqlPDPPromoContainerTop: (pdpVariantName) => (
            <GraphqlPDPPromoContainer
                pdpVariantName={pdpVariantName}
                parentCategories={product.parentCategories}
                categoryId={location.state?.categoryId || ''}
                position="Top"
                featureFlags={featureFlags}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        ),

        GraphqlPDPPromoContainer: (pdpVariantName) => (
            <GraphqlPDPPromoContainer
                pdpVariantName={pdpVariantName}
                parentCategories={product.parentCategories}
                categoryId={location.state?.categoryId || ''}
                position="Bottom"
                featureFlags={featureFlags}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        ),

        SubscriptionProductBannerUI: (pdpVariantName) => (
            <SubscriptionProductBannerUI
                pdpVariantName={pdpVariantName}
                brand={brand}
                location={location}
                product={product}
                productBaseContent={productBaseContent}
                subscription={subscription}
                subscriptionDetails={subscriptionDetails}
                triggerSubscriptionCheck={triggerSubscriptionCheck}
                selectedSku={selectedSku}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
            />
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        PmallSummary: (pdpVariantName) => (
            <PmallSummary
                pdpVariantName={pdpVariantName}
                pageType="pdp"
                product={product}
                onHandleModalPmall={setPmallModalOpen}
                selectedSku={selectedSku}
                location={location}
                quantity={quantity}
                handleMiniCartModalClick={handleMiniCartModalClick}
            />
        ),

        PmallPersonalization: (pdpVariantName) => (
            <PmallPersonalization
                pdpVariantName={pdpVariantName}
                isOpen={pmallModalOpen}
                product={product}
                sku={selectedSku.id}
                handleModalPmall={setPmallModalOpen}
                pageType="pdp"
                isPassportBundleProduct={isPassportBundleProduct || {}}
                location={location}
                personalizedData={personalizedData}
                selectedSku={selectedSku}
                quantity={quantity}
                deliveryIndicatorPDP={deliveryIndicator}
                deliveryMethod={deliverySLA}
                handleMiniCartModalClick={handleMiniCartModalClick}
            />
        ),

        PassportBannerUI: (pdpVariantName) => (
            <PassportBannerContainer selectedSku={selectedSku} isPassportThreshold>
                <PassportBannerUI
                    pdpVariantName={pdpVariantName}
                    invokedFrom="StandardProductsPage"
                    bannerOnPage="product"
                    enrollmentPage={enrollmentPage}
                    product={product}
                    location={location}
                    passportMemberImg={passportMemberImg}
                    isPassportBundleItem={isPassportBundleItem}
                    isPassportBundleProduct={isPassportBundleProduct || {}}
                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                    isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                />
            </PassportBannerContainer>
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        NBCUMovieBanner: (pdpVariantName) => (
            <NBCUMovieBanner
                pdpVariantName={pdpVariantName}
                isStandAloneMovieSku={isStandAloneMovieSku}
                skuData={location?.state?.showMovieUpsell}
                selectMovieSku={selectMovieSku}
                movieSelected={movieSelected}
            />
        ),

        PDPAddToCart: (pdpVariantName, showAddToCart = true, showDeliveryField = true) => (
            <PDPAddToCart
                pdpVariantName={pdpVariantName}
                movieSelected={movieSelected?.skuSelected ? movieSelected : null}
                selectMovieSku={selectMovieSku}
                brand={brand}
                validVaseConfiguratorSku={validVaseConfiguratorSku}
                presentation_family={presentation_family}
                addonsGroups={product.addonGroups || []}
                addToCartData={addToCartData}
                baseProductSku={baseProduct}
                content={content}
                deliveryData={deliveryData}
                deliveryIndicator={deliveryIndicator}
                deliverySLA={deliverySLA}
                deviceType={deviceType}
                disableAddToCart={disableAddToCart}
                getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                handleMiniCartModalClick={handleMiniCartModalClick}
                handleMobileAgeVerification={handleMobileAgeVerification}
                handlePersonalizeInputChange={handlePersonalizeInputChange}
                handleSkuChange={handleSkuChange}
                hasAddons={hasAddons}
                hasWine={hasWine}
                hide18FCheckbox={hide18FCheckbox}
                image={productImage}
                isAddToCartEnabled={isAddToCartEnabled}
                isPassportBundleItem={isPassportBundleItem}
                isPassportBundleProduct={isPassportBundleProduct || {}}
                isStandAloneMovieSku={isStandAloneMovieSku}
                location={location}
                mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                mobileGiftData={smartGiftAddressSection}
                partNumber={product.partNumber}
                passportMemberImg={passportMemberImg}
                personalization={personalization}
                personalizedData={personalizedData}
                price={selectedSku?.price}
                product={product}
                productNotAvailable={productNotAvailable}
                productUrl={productUrl}
                quantity={quantity}
                selectedSku={selectedSku}
                setProductQuantity={setProductQuantity}
                sku={selectedSku?.id}
                skuConfig={skuConfig}
                skuData={sortedData} // dupe of sorted data
                sortedData={sortedData} // dupe of skuData
                subscription={subscription}
                subscriptionDetails={subscriptionDetails}
                triggerSubscriptionCheck={triggerSubscriptionCheck}
                updateWineStatus={updateWineStatus}
                productBaseContent={productBaseContent}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                showAddToCart={showAddToCart}
                showDeliveryField={showDeliveryField}
                showProductTitleTop={showProductTitleTop}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                addToCartButtonRedesign={isForcePdpAddToCartRedesignEnabled}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
                stickyAtcEnabled={stickyAtcEnabled}
                stickyAtcRequiresSavedZip={stickyAtcRequiresSavedZip}
            />
        ),

        ProductTitleTop: () => (
            <ProductTitleTop
                product={product}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                selectedSku={selectedSku}
                isPassportBundleProduct={isPassportBundleProduct}
                skuData={sortedData}
                productUrl={productUrl}
                skuCount={product?.productSkus?.length || 0}
                hasAddons={product?.addonGroups?.length > 0}
                content={content}
            />
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        OneClickPaymentBuilder: (pdpVariantName) => (
            <OneClickPaymentBuilder
                pdpVariantName={pdpVariantName}
                selectedSku={selectedSku}
                movieSelected={movieSelected}
                isStandAloneMovieSku={isStandAloneMovieSku}
            />
        ),

        GoDeluxe: (pdpVariantName, forNewUpsells = false) => (
            <GoDeluxe
                pdpVariantName={pdpVariantName}
                selectedSku={selectedSku}
                handleSkuChange={handleSkuChange}
                goDeluxeUpsells={product?.upsells}
                sortedData={sortedData}
                upsellNewDesign={forNewUpsells}
                skuConfig={skuConfig}
                isPdpRedesignEnabled={isPdpRedesignEnabled}

            />
        ),

        PDPDeliveryPopupContainer: (pdpVariantName) => (
            !hideDeliveryType
            && (
                <PDPDeliveryPopupContainer
                    pdpVariantName={pdpVariantName}
                    brand={brand}
                    presnetation_family={presentation_family}
                    productDeliveryType={productDeliveryType}
                    isPDPCalendarPopupEnabled={(featureFlags['is-design-and-delivery-popup-enabled'] || isDeliveryEnabled) && !isPDPDeliveryPopupShow}
                    featureFlags={featureFlags}
                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                    showProductTitleTop={showProductTitleTop}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                    productBrand={product?.brandId}
                    product={product}
                />
            )
        ),

        PromoMessageUI: (pdpVariantName) => (
            <PromoMessageUI
                pdpVariantName={pdpVariantName}
                isPromoRestricted={product?.isPromoRestricted}
                productBaseContent={productBaseContent}
                content={content}
                featureFlags={featureFlags}
                presentationFamily={presentation_family}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
            />
        ),

        // documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page

        ProductDetails: (pdpVariantName, isSinglePlaThree = false, renderDescriptionOnly = false, renderContentOnly = false) => (
            <ProductDetails
                pdpVariantName={pdpVariantName}
                product={product}
                selectedSku={selectedSku}
                content={content}
                isPassportBundleProduct={isPassportBundleProduct || {}}
                presentationFamily={presentation_family}
                ageVerifyFlag={selectedSku?.ageVerifyFlag}
                showProductDetailsHere={featureFlags['is-pdp-v-2-enabled']}
                productBaseContent={productBaseContent}
                isPmallAltDescriptionLocation={featureFlags['is-pmall-alternate-description-location']}
                isSinglePlaThree={isSinglePlaThree}
                renderDescriptionOnly={renderDescriptionOnly}
                renderContentOnly={renderContentOnly}
                isPDPVariationDesign={isPDPVariationDesign}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        ),

        SubstitutionMessage: (pdpVariantName) => (
            <SubstitutionMessage
                content={content}
                presentationFamily={presentation_family}
                pdpVariantName={pdpVariantName}
                data={product}
                productBaseContent={productBaseContent}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                showProductTitleTop={showProductTitleTop}
            />
        ),
        PassportEligibleImage: (pdpVariantName) => (
            <PassportEligibleImage
                presentationFamily={presentation_family}
                pdpVariantName={pdpVariantName}
                isPassportBannerEnabled={shouldShowPassportEligiblePdpTag}
                passportData={passportData}
            />
        ),
        RecommendationsBuilder: () => (
            <RecommendationsBuilder
                featureFlags={featureFlags}
                product={product}
                sortedData={sortedData}
                recommendations={content?.entries?.[0]?.recommendations}
                productBaseContent={productBaseContent}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
                plaUpperCarousel
            />
        ),
        PlaRedesignProductImage: () => (
            <GraphqlProductImageUI
                brand={brand}
                // TODO remap to product, data duplicate prop
                data={product}
                isSmartGiftEnabled={isSmartGiftEnabled}
                location={location}
                presentationFamily={presentation_family}
                productBaseContent={productBaseContent}
                selectedSku={selectedSku}
                smartGiftLetThemKnowSection={smartGiftLetThemKnowSection}
                featureFlags={featureFlags}
                isPlaPage={isPlaPage}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
                selectedSkuBasedAltImages={featureFlags['has-alt-images-pim-sourced']}
            />
        ),
    };

    const headerBannerUrl = ssrDeviceType === 'mobile' ? headerBanner?.mobile_image?.url : headerBanner?.image?.url;
    const headerBannerAlt = ssrDeviceType === 'mobile' ? headerBanner?.mobile_image?.title : headerBanner?.image?.title;
    const isFlowerDesktop = presentation_family === 'flower' && !isMobile;
    const isFlowerMobile = presentation_family === 'flower' && isMobile;
    const foodPlaRedesign = useSelector(getFeatureFlag('which-food-pla-design'));
    const descriptionToTop = useSelector(getActiveABTest('description_after_atc'));
    const upSell = sortedData.filter((sku) => sku.__typename === 'Upsell');
    const hasPlaTemplate = useSelector(getFeatureFlag('has-pla-template'));
    const plaPage = (featureFlags['is-simplified-pdp'] && isPlaPage && foodPlaRedesign === 'variant') || (isPlaPage && hasPlaTemplate);

    const plaGiftFinderEnabled = (isPlaPage || isDisplayChannel) && foodPlaRedesign === 'three_column';

    if (pdpDeliveryLoading || pdpDeliveryVariable?.skip) {
        if (featureFlags['is-pla-flow-enabled'] && isProductListingAd(location.search)) {
            return <PLASkeleton />;
        }
        return (
            <Media
                query="(min-width: 599px)"
            >
                {(matches) => (matches
                    ? <PDPSkeleton />
                    : <MobilePDPSkeleton />

                )}
            </Media>
        );
    }

    const getClass = () => {
        let styleCss = '';
        if (presentation_family === 'food') {
            styleCss = `${classes.foodRoot} ${isPdpRedesignEnabled ? classes.foodWrapper : ''} ${isShowProductReviewsStarDistribution ? '' : classes.hidePRStarDistribution}`;
        } else if (presentation_family === 'flower') {
            styleCss = `${classes.flowerRoot} ${isPdpRedesignEnabled ? classes.flowerWrapper : ''} ${isShowProductReviewsStarDistribution ? '' : classes.hidePRStarDistribution}`;
        }
        return styleCss;
    };

    const showAggregatedRating = () => (featureFlags['is-show-product-reviews-aggregated-star-rating'] ? 'gold-stars' : 'pr-Review-Image-Display-Disclaimer pr-reviewdisplay-no-aggregated-star-rating black-stars');
    const showRatingDistribution = () => (featureFlags['is-show-product-reviews-star-distribution'] ? '' : classes.hidePRStarDistribution);
    return (
        <div className={getClass()} data-testid={`${presentation_family}_rendered`}>
            {featureFlags['is-card-isle-pdp-add-on'] && cardIsleEnabled && isPmallCardIsleFlow && <LoadCardIslePDP />}
            {headerBannerUrl && (
                headerBanner?.link?.href ? (
                    <Link
                        to={headerBanner.link.href}
                        className={classes.headerImageContainer}
                    ><img className={classes.headerImage} src={headerBannerUrl} alt={headerBannerAlt} />
                    </Link>
                ) : (
                    <img className={classes.headerImage} src={headerBannerUrl} alt={headerBannerAlt} />
                )
            )}
            {isFlowerMobile && (featureFlags['is-pdp-redesign-enabled'] || isForcePdpRedesignEnabled)
                && (
                    <div className={`${classes.breadCrumbBody} ${classes.breadCrumbBody}--mobile-pdp-redesign`}>
                        {getBreadcrumbArray(product, location)}
                    </div>
                )}
            {(presentation_family === 'food' || isFlowerDesktop)
                && (
                    <div
                        className={`${(hideProductRecomendation && ssrDeviceType === 'mobile') && classes.showBreadCrumbBody} ${plaPage && classes.plaBreadCrumb} ${classes.breadCrumbBody} ${classes.breadCrumbBody}--desktop`}
                    >
                        {getBreadcrumbArray(product, location)}
                    </div>
                )}

            <PDPVariantController
                components={components}
                product={product}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                showProductTitleTop={showProductTitleTop}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                isPlaRedesignEnabled={isPlaRedesignEnabled}
                upSell={upSell?.length > 0}
                selectedSku={selectedSku}
                isPassportAfterCta={isPassportAfterCta}
            />
            {featureFlags['is-pdp-new-layout-enabled'] && <PDPLargePromoContainer />}
            <div className={`${classes.contentBottom} ${featureFlags['is-pdp-yotpo-ratings-enabled'] ? '' : classes.yotpoRatings}`}>
                {((descriptionToTop === 'variant' && !isPdpRedesignEnabled) || (presentation_family === 'food' && isPdpRedesignEnabled && !isPlaRedesignEnabled)) && (
                    <ProductDetails
                        product={product}
                        selectedSku={selectedSku}
                        content={content}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                        presentationFamily={presentation_family}
                        ageVerifyFlag={selectedSku?.ageVerifyFlag}
                        showProductDetailsHere={!featureFlags['is-pdp-v-2-enabled'] || isPdpRedesignEnabled}
                        productBaseContent={productBaseContent}
                        isPmallAltDescriptionLocation={featureFlags['is-pmall-alternate-description-location']}
                        isDescriptionTabEnabled={featureFlags['is-pdp-description-tabs-enabled']}
                        isPDPVariationDesign={isPDPVariationDesign}
                        isPdpRedesignFood={isPdpRedesignEnabled}
                    />
                )}

                {plaGiftFinderEnabled && (
                    <PLAPDPGiftFinderQuery
                        brand={brand}
                        plaGiftFinderEnabled={plaGiftFinderEnabled}
                    />
                )}
                {((isPlaPage && foodPlaRedesign === 'three_column') || !hideProductRecomendation) && !isMobile && !isPlaRedesignEnabled && (
                    <PLACollectionRecsABWrapper
                        brand={brand}
                        partNumber={product.partNumber}
                        productName={productName}
                        skuData={sortedData}
                    />
                )}

                {/* replaced product_recommendations_service with default content recommendations for making configurable text attributes */}
                <div className={classes.recommendations}>
                    <RecommendationsBuilder
                        featureFlags={featureFlags}
                        product={product}
                        sortedData={sortedData}
                        recommendations={content?.entries?.[0]?.recommendations}
                        productBaseContent={productBaseContent}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                        hideMoreRecommendation={isPlaRedesignEnabled}
                        isPlaRedesignEnabled={false}
                        hideRecentlyViewed={isPlaEnabled && (featureFlags['is-pla-sf-recs-enabled-pwa'] || false)} // for PLARecsABWrapper
                    />
                </div>
                {questionAndAnswersAIEnabled &&  (
                    <QuestionsAndAnswersAI
                        product={product}
                        selectedSku={selectedSku}
                        featureFlags={featureFlags}
                    />
                )}
                {isPlaEnabled && (
                    <PLARecsABWrapper
                        isPlaEnabled={isPlaEnabled}
                        urlParams={urlParams}
                        trackEvent={trackEvent}
                        product={product}
                        skuData={sortedData}
                        isPlaRedesignEnabled={isPlaRedesignEnabled}
                        recommendations={productBaseContent?.entries?.[0]?.recommendations?.length > 0 ? productBaseContent?.entries?.[0]?.recommendations : content?.entries?.[0]?.recommendations}
                        featureFlags={featureFlags}
                    />
                )}

                {showOoakYotpoSlider && (
                    <div className={classes.ooakSliderContainer}>
                        <div className={classes.ooakSliderHeader}>{heading}</div>
                        <ReactMarkdown source={sub_heading} escapeHtml={false} />
                        <div className="yotpo yotpo-pictures-widget" data-gallery-id={gallery_id} />
                    </div>
                )}

                {(passportBundleDetails?.desktopImage?.title
                    && passportBundleDetails?.desktopImage?.url
                    && passportBundleDetails?.mobileImage?.title
                    && passportBundleDetails?.mobileImage?.url)
                    && (!hasEnrollmentConfig || isPassportEnrollmentActive(featureFlags, enrollmentPage))
                    && <PassportBundleBanner bundleDetails={passportBundleDetails} />}

                {((descriptionToTop !== 'variant' && !isPdpRedesignEnabled) || isPdpRedesignShortEnabled || isPlaRedesignEnabled) && (
                    <ProductDetails
                        product={product}
                        selectedSku={selectedSku}
                        content={content}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                        presentationFamily={presentation_family}
                        ageVerifyFlag={selectedSku?.ageVerifyFlag}
                        showProductDetailsHere={!featureFlags['is-pdp-v-2-enabled']}
                        productBaseContent={productBaseContent}
                        isPmallAltDescriptionLocation={featureFlags['is-pmall-alternate-description-location']}
                        isDescriptionTabEnabled={featureFlags['is-pdp-description-tabs-enabled']}
                        isPDPVariationDesign={isPDPVariationDesign}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                        isPlaRedesignEnabled={isPlaRedesignEnabled}
                    />
                )}

                {yotpoSliderProduct && <div className="yotpo yotpo-pictures-widget" data-gallery-id={mbpUtil.getEnv('APP_YOTPO_DATA_GALLERY_ID')} />}

                <MarketingSpotsNupPDP productData={product} />
                {/* Marketing PDP Espots */}
                {featureFlags['is-pdp-marketing-block-enabled-pwa'] ? (
                    <MarketingSpotsPDP
                        productData={product}
                    />
                ) : (
                    <Track
                        category="Product Page"
                        action="PDP Marketing spot disabled"
                    />
                )}

                {isPdpReviewsEnabled && isPowerReviewEnabled && ''}
                {isPdpReviewsEnabled && featureFlags['is-pdp-yotpo-enabled'] && featureFlags['is-yotpo-review-legal-copy-pdp-enabled'] && ((activeABTests?.product_reviews !== 'hide' && brand?.id === '1001') || brand?.id !== '1001') && (
                    <YotpoReviewsLegalCopy />
                )}
                {(isVariantPdpPowerReviewsDisplayAndSnippet)
                    && (
                        <div style={{ margin: '0 10px' }}>
                            <div
                                id="pr-reviewdisplay"
                                className={`${classes.prReviewDisplay} pr-Review-Display-Snapshot-Mobile ${showAggregatedRating()} ${showRatingDistribution()}`}
                            />
                            <div
                                id="pr-questiondisplay"
                                className={classes.prQuestionDisplay}
                            />
                        </div>
                    )}
                {isPdpReviewsEnabled && featureFlags['is-pdp-yotpo-enabled'] && ((activeABTests?.product_reviews !== 'hide' && brand?.id === '1001') || brand?.id !== '1001')
                    && (
                        <div
                            ref={clickableDivRef}
                            className="yotpo yotpo-main-widget"
                            data-product-id={yotpoConfig.partNumber}
                            data-price={yotpoConfig?.price?.prices?.[1]?.value}
                            data-currency="USD"
                            data-name={yotpoConfig.name}
                            data-url={location.pathname}
                            data-image-url={`${product.image?.path}${product.image?.name}x.jpg`}
                        />
                    )}
                {isFlowerMobile && (!featureFlags['is-pdp-redesign-enabled'] || !isForcePdpRedesignEnabled)
                    && (
                        <div className={`${classes.breadCrumbBody} ${classes.breadCrumbBody}--mobile`}>
                            {getBreadcrumbArray(product, location)}
                        </div>
                    )}
            </div>
        </div>
    );
};

StandardProductsPage.propTypes = {
    featureFlags: object.isRequired,
    product: object.isRequired,
    location: object.isRequired,
    passportData: object.isRequired,
    brand: object.isRequired,
    content: object.isRequired,
    addToCartData: addToCartDataType.isRequired,
    baseProduct: array.isRequired,
    deliveryData: object.isRequired,
    deliveryIndicator: string.isRequired,
    deliverySLA: string.isRequired,
    deviceType: string.isRequired,
    disableAddToCart: bool.isRequired,
    hasAddons: bool.isRequired,
    hasWine: bool.isRequired,
    hide18FCheckbox: bool.isRequired,
    isAddToCartEnabled: bool.isRequired,
    isPassportBundleItem: bool.isRequired,
    isPassportBundleProduct: object.isRequired,
    isPlaEnabled: bool.isRequired,
    isStandAloneMovieSku: bool.isRequired,
    mobileAgeVerificationOpen: bool.isRequired,
    passportMemberImg: string.isRequired,
    personalization: object.isRequired,
    personalizedData: object.isRequired,
    presentation_family: string.isRequired,
    productBaseContent: object.isRequired,
    productDisplay: string.isRequired,
    productUrl: string.isRequired,
    quantity: string.isRequired,
    selectedSku: object.isRequired,
    skuConfig: object.isRequired,
    smartGiftAddressSection: string.isRequired,
    smartGiftLetThemKnowSection: object.isRequired,
    sortedData: array.isRequired,
    subscription: object.isRequired,
    subscriptionDetails: object.isRequired,
    urlParams: object.isRequired,
    validVaseConfiguratorSku: bool.isRequired,

    updateWineStatus: func.isRequired,
    getUpdatedPersonalizedProdData: func.isRequired,
    handleMiniCartModalClick: func.isRequired,
    handleMobileAgeVerification: func.isRequired,
    handlePersonalizeInputChange: func.isRequired,
    handleSkuChange: func.isRequired,
    setProductQuantity: func.isRequired,
    triggerSubscriptionCheck: func.isRequired,
    setVaseConfiguratorSku: func.isRequired,
    trackEvent: func.isRequired,
    yotpoCustomerReviewsGallery: object.isRequired,
    activeABTests: object,
    passportBundleDetails: object,
    handleSkuClick: func.isRequired,
    isPassportAfterCta: bool,
};

StandardProductsPage.defaultProps = {
    activeABTests: {},
    passportBundleDetails: {},
    isPassportAfterCta: false,
};

const mapStateToProps = (state) => ({
    activeABTests: getActiveABTests(state),
    passportBundleDetails: getPassportBundleData(state),
});

const enhance = compose(
    connect(mapStateToProps, null),
);

export default enhance(StandardProductsPage);
